export enum XpressDisciplinaryReasonsEnum {
    None = 0,
    InsufficientEvidence = 1,
    CannotContactCustomer = 2,
    DriverNotAtFault = 3
}
